import { isProduction } from '@/utils/envHelpers';

export { isProduction };
